import { render, staticRenderFns } from "./scatterMap.vue?vue&type=template&id=4c28a6e5"
import script from "./scatterMap.vue?vue&type=script&lang=js"
export * from "./scatterMap.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data01/test/dev.console.insureforce.cn/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4c28a6e5')) {
      api.createRecord('4c28a6e5', component.options)
    } else {
      api.reload('4c28a6e5', component.options)
    }
    module.hot.accept("./scatterMap.vue?vue&type=template&id=4c28a6e5", function () {
      api.rerender('4c28a6e5', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/echarts/map/components/scatterMap.vue"
export default component.exports